import { render, staticRenderFns } from "./TellThemCollegePrepModal.vue?vue&type=template&id=47fae928&scoped=true&"
import script from "./TellThemCollegePrepModal.vue?vue&type=script&lang=js&"
export * from "./TellThemCollegePrepModal.vue?vue&type=script&lang=js&"
import style0 from "./TellThemCollegePrepModal.vue?vue&type=style&index=0&id=47fae928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fae928",
  null
  
)

export default component.exports